import { render, staticRenderFns } from "./ZapeGalleryModel.vue?vue&type=template&id=01dcc86e&"
import script from "./ZapeGalleryModel.vue?vue&type=script&lang=js&"
export * from "./ZapeGalleryModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports